export const colors = {
  primary: {
    DEFAULT: '#4A6A51', // Forest Green
    light: '#6B8E70',
    dark: '#3A5540',
  },
  secondary: {
    DEFAULT: '#8F7E67', // Medium Brown
    light: '#A99A84',
    dark: '#6F604E',
  },
  neutral: {
    '0': '#FFFFFF',
    '100': '#F9FAFB',
    '200': '#F3F4F6',
    '300': '#E5E7EB',
    '400': '#D1D5DB',
    '500': '#9CA3AF',
    '600': '#6B7280',
    '700': '#4B5563',
    '800': '#374151',
    '900': '#1F2937',
    '1000': '#111827',
  },
  background: {
    primary: '#FBF9F6', // Very light beige
    secondary: '#F3F0E9', // Light beige
    tertiary: '#E4D8C4', // Tan
    overlay: 'rgba(58, 85, 64, 0.4)',
  },
  text: {
    primary: '#3D352E', // Dark Brown
    secondary: '#8F7E67', // Medium Brown
    muted: '#C2A988', // Light Brown/Tan
    white: '#FFFFFF',
    primaryAccent: '#4A6A51',
  },
  border: {
    primary: '#E4D8C4',
    secondary: '#F3F0E9',
    interactive: '#C2A988',
  },
  status: {
    success: '#10B981',
    warning: '#E0B450', // Mustard Yellow
    error: '#EF4444',
    info: '#3B82F6',
  },
  gradients: {
    primary: 'linear-gradient(135deg, #6B8E70 0%, #4A6A51 100%)',
    secondary: 'linear-gradient(135deg, #A99A84 0%, #8F7E67 100%)',
    blackOverlay: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 60%)',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)',
  },
} as const;
